import { render, staticRenderFns } from "./handlingUnqualifieds.vue?vue&type=template&id=468073fe&scoped=true"
import script from "./handlingUnqualifieds.vue?vue&type=script&lang=js"
export * from "./handlingUnqualifieds.vue?vue&type=script&lang=js"
import style0 from "./handlingUnqualifieds.vue?vue&type=style&index=0&id=468073fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468073fe",
  null
  
)

export default component.exports